import Login from '../views/authentication/login';
import ForgotPassword from '../views/authentication/forgot-password';
import ResetPassword from '../views/authentication/reset-password';
import ResendEmail from '../views/authentication/resend-email';
import EmailConfirmation from '../views/authentication/email-confirmation/EmailConfirmation';
import MfaChallenge from '../views/authentication/verify-mfa';
import MfaSetup from '../views/authentication/setup-mfa';

export default [
  {
    path: '/resend-email',
    component: ResendEmail,
  },
  {
    path: '/email-confirmation',
    component: EmailConfirmation,
  },
  {
    path: '/forgot-password',
    component: ForgotPassword,
  },
  {
    path: '/reset-password',
    component: ResetPassword,
  },
  {
    path: '/verify-mfa',
    component: MfaChallenge,
  },
  {
    path: '/mfa-setup',
    component: MfaSetup,
  },
  {
    path: '/login',
    component: Login,
  },
  {
    path: '/',
    component: Login,
  },
];